/* istanbul ignore file */
export default {

};
